import React from 'react'
import Heading from './Heading'
import { Grid } from '@mui/material'
import FullName from './FullName'
import Email from './Email'
import Address from './Address'
import DatePickers from './DatePicker'
import Number from './Number'
import LongText from './LongText'

const DonationTrackingForm = () => {
    return (
        <Grid p={{ xs: '40px 13px', md: '40px 52px' }} bgcolor={'white'} borderRadius={'20px'} width={'100%'} maxWidth={'700px'} boxShadow={'0 4px 4px rgba(87,100,126,.21)'} m={{ xs: '72px 0px', md: '72px 42px' }}>
            <Heading header={'فرم پیگیری کمک‌های مالی'} subHeader={''} />
            <Grid className='states' display={'flex'} flexDirection={'column'} alignItems={'flex-start'} justifyContent={'flex-start'}>
                <FullName header={'نام اهدا کننده'} />
                <Email header={'ایمیل اهداکننده'} />
                <Address header={'آدرس اهداکننده'} />
                <DatePickers header={'تاریخ اهدا'}/>
                <Number header={'مبلغ اهدایی'}/>
                <LongText header={'یادداشت‌ها'} />
            </Grid>
        </Grid>
    )
}

export default DonationTrackingForm
